<template>
  <div>
    <div class="BackupPlanName-title">
      <Breadcrumb>
        <BreadcrumbItem
          to="/resourceConfigurationManagement/aws/ecs"
        >{{ $t('RAM.AWS.ECS.title') }}</BreadcrumbItem
        >
        <BreadcrumbItem>{{ $t('RAM.AWS.ECS.clusterDescription') }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <div>
      <Tabs value="name1" @on-click="clickTab">
        <TabPane :label="$t('RAM.AWS.ECS.service')" name="name1">
          <Table
            :loading="serviceLoading"
            :no-data-text="$t('common.noData')"
            :columns="serviceColumns"
            :data="tableServiceListData"
            style="width: 100%;"
          ></Table>
          <Page
            :current="current1"
            :total="dataTotal1"
            show-sizer
            :page-size="pageSize1"
            @on-change="changePage1"
            @on-page-size-change="changeSize1"
            :transfer="true"
          ></Page>
        </TabPane>
        <TabPane :label="$t('RAM.AWS.ECS.task')" name="name2">
          <Table
            :loading="taskLoading"
            :no-data-text="$t('common.noData')"
            :columns="jobColumns"
            :data="tableTaskListData"
            style="width: 100%;"
          ></Table>
          <Page
            :current="current2"
            :total="dataTotal2"
            show-sizer
            :page-size="pageSize2"
            @on-change="changePage2"
            @on-page-size-change="changeSize2"
            :transfer="true"
          ></Page>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
var tableDateVue = {};
export default {
  name: "BackupPlanName",
  data() {
    return {
      current1: 1,
      dataTotal1: 0,
      pageSize1: 10,
      current2: 1,
      dataTotal2: 0,
      pageSize2: 10,
      serviceLoading: false,
      taskLoading: false,
      serviceColumns: [
        {
          title: this.$t('RAM.AWS.ECS.serviceName'),
          key: "serviceName",
        },
        {
          title: 'ARN',
          key: "serviceArn",
        },
        {
          title: this.$t('RAM.AWS.ECS.status'),
          key: "statusName",
        },
        {
          title: this.$t('RAM.AWS.ECS.serviceType'),
          key: 'schedulingStrategyName'
        },
        {
          title: this.$t('RAM.AWS.ECS.rolloutState'),
          key: 'rolloutStateName'
        },
        {
          title: this.$t('RAM.AWS.ECS.taskDefinition'),
          key: 'taskDefinition'
        },
        {
          title: this.$t('RAM.AWS.ECS.launchType'),
          key: 'launchTypeName'
        }
      ],
      jobColumns: [
        {
          title: this.$t('RAM.AWS.ECS.task'),
          key: "taskArn",
        },
        {
          title: this.$t('RAM.AWS.ECS.lastStatus'),
          key: "lastStatusName",
        },
        {
          title: this.$t('RAM.AWS.ECS.desiredStatus'),
          key: "desiredStatusName",
        },
        {
          title: this.$t('RAM.AWS.ECS.taskDefinition'),
          key: 'taskDefinitionArn'
        },
        {
          title: this.$t('RAM.AWS.ECS.runningState'),
          key: 'healthStatusName'
        },
        {
          title: this.$t('RAM.AWS.ECS.startTime'),
          key: 'createdAt'
        },
        {
          title: this.$t('RAM.AWS.ECS.containerInstance'),
          key: 'containerInstanceArn '
        },
        {
          title: this.$t('RAM.AWS.ECS.launchType'),
          key: 'launchTypeName'
        },
        {
          title: this.$t("RAM.AWS.eks.platformVersion"),
          key: 'platformVersion'
        },
        {
          title: 'CPU(vCPU)',
          key: 'cpu'
        },
        {
          title: this.$t('RAM.AWS.ECS.memory'),
          key: 'memory'
        }
      ],
      tableServiceListData: [],
      tableTaskListData: [],
    };
  },
  beforeCreate() {
    tableDateVue = this;
  },
  mounted() {
    tableDateVue.getServiceData();
  },
  methods: {
    // 获取服务分页数据
    getServiceData() {
      this.serviceLoading = true;
      this.$api.cmdb
        .pagingQueryEcsService({ resourceAwsEcsId: this.$route.query.id, pageNum: this.current1, pageSize: this.pageSize1 })
        .then((res) => {
          this.tableServiceListData = res.data.records;
        })
        .finally(() => {
          this.serviceLoading = false;
        });
    },
    // 获取任务分页数据
    getTaskData() {
      this.taskLoading = true;
      this.$api.cmdb
        .pagingQueryEcsTask({ resourceAwsEcsId: this.$route.query.id, pageNum: this.current1, pageSize: this.pageSize1 })
        .then((res) => {
          this.tableTaskListData = res.data.records;
        })
        .finally(() => {
          this.taskLoading = false;
        });
    },
    clickTab(val) {
      if (val === 'name1') {
        this.current1 = 1;
        this.pageSize1 = 10;
        this.getServiceData();
      } else {
        this.current2 = 1;
        this.pageSize2 = 10;
        this.getTaskData()
      }
    },
    changePage1(current) {
      this.current1 = current;
      tableDateVue.getServiceData();
    },
    changeSize1(pageSize) {
      this.pageSize1 = pageSize;
      tableDateVue.getServiceData();
    },
    changePage2(current) {
      this.current2 = current;
      tableDateVue.getTaskData();
    },
    changeSize2(pageSize) {
      this.pageSize2 = pageSize;
      tableDateVue.getTaskData();
    }
  },
};
</script>

<style scoped>
.BackupPlanName-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.date {
  margin-top: 20px;
  margin-bottom: 10px;
}
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ecs/clusterDescription.vue